import { LegalDocument } from './LegalDocument';
import { SITE } from '../data/site';

export function TermsOfService() {
  return (
    <LegalDocument
      title="Terms of Service"
      intro={`The rules of the arcade. By playing ${SITE.name}, you agree to these terms.`}
      lastUpdated={SITE.legalLastUpdated}
      sections={[
        {
          heading: 'Acceptance of terms',
          body: (
            <p>
              These Terms of Service (&ldquo;Terms&rdquo;) govern your use of {SITE.name}, operated by{' '}
              {SITE.legalEntity}. By accessing or using the arcade, you agree to be bound by these
              Terms. If you do not agree, please do not use the arcade.
            </p>
          ),
        },
        {
          heading: 'The arcade & free play',
          body: (
            <p>
              {SITE.name} is a browser-based arcade of original games. You can try a demo of any game
              for free, and play a limited number of free rounds without an account. Free play is
              provided &ldquo;as is,&rdquo; and the number of free rounds and how they reset may change
              over time.
            </p>
          ),
        },
        {
          heading: 'Accounts',
          body: (
            <>
              <p>
                Some features — saving high scores across devices, daily play tokens, and purchasing a
                Pass — require an account. You agree to provide accurate information and to keep your
                login credentials secure. You are responsible for activity under your account.
              </p>
              <p>
                You must be at least 13 years old (or the minimum age of digital consent in your
                country) to create an account.
              </p>
            </>
          ),
        },
        {
          heading: 'Tokens & Passes',
          body: (
            <>
              <p>
                Signed-in players receive a daily allotment of play tokens that refresh each day. When
                tokens run out, you can keep playing by purchasing a <strong>Pass</strong> — a Day,
                Week, or Month of unlimited plays.
              </p>
              <ul>
                <li>
                  <strong>Passes unlock unlimited plays</strong> for their duration across the whole
                  cabinet.
                </li>
                <li>
                  <strong>Tokens have no cash value</strong>, cannot be transferred, exchanged, or
                  redeemed for money, and may expire.
                </li>
                <li>
                  A round started against your token balance spends a token, including retries — plan
                  your continues accordingly.
                </li>
              </ul>
            </>
          ),
        },
        {
          heading: 'Payments & billing',
          body: (
            <>
              <p>
                Passes are sold and billed through <strong>PayPal</strong>. Recurring Passes renew
                automatically at the end of each period until you cancel. You can cancel a recurring
                Pass at any time; cancellation stops future renewals and takes effect at the end of the
                current period.
              </p>
              <p>
                Prices are shown at the point of purchase and may change with notice. Except where
                required by law, purchases are non-refundable once the Pass period has begun.
              </p>
            </>
          ),
        },
        {
          heading: 'Acceptable use',
          body: (
            <>
              <p>You agree not to:</p>
              <ul>
                <li>Cheat, tamper with score submissions, or manipulate the leaderboards.</li>
                <li>Circumvent free-play metering, token limits, or Pass entitlements.</li>
                <li>Reverse-engineer, scrape, or disrupt the arcade or its infrastructure.</li>
                <li>Use the arcade for any unlawful purpose or to infringe others&rsquo; rights.</li>
              </ul>
              <p>
                We may suspend or terminate access that violates these Terms or threatens the integrity
                of the arcade.
              </p>
            </>
          ),
        },
        {
          heading: 'Intellectual property',
          body: (
            <p>
              The games, artwork, sound, code, and the {SITE.name} name and marks are owned by{' '}
              {SITE.legalEntity} or its licensors and are protected by intellectual-property laws. The
              arcade&rsquo;s 1984 setting is a work of fiction. We grant you a personal, non-exclusive,
              non-transferable license to play the games for your own entertainment — nothing more.
            </p>
          ),
        },
        {
          heading: 'Disclaimers',
          body: (
            <p>
              The arcade is provided &ldquo;as is&rdquo; and &ldquo;as available,&rdquo; without
              warranties of any kind, whether express or implied. We do not warrant that the arcade
              will be uninterrupted, error-free, or that scores and saves will never be lost.
            </p>
          ),
        },
        {
          heading: 'Limitation of liability',
          body: (
            <p>
              To the maximum extent permitted by law, {SITE.legalEntity} will not be liable for any
              indirect, incidental, special, or consequential damages arising from your use of the
              arcade. Our total liability for any claim relating to the arcade will not exceed the
              amount you paid us in the twelve months before the claim.
            </p>
          ),
        },
        {
          heading: 'Changes to these terms',
          body: (
            <p>
              We may update these Terms as the arcade evolves. When we make material changes, we&rsquo;ll
              revise the &ldquo;Last updated&rdquo; date. Continued use after changes take effect means
              you accept the updated Terms.
            </p>
          ),
        },
        {
          heading: 'Contact',
          body: (
            <p>
              Questions about these Terms? Email{' '}
              <a href={`mailto:${SITE.emails.support}`}>{SITE.emails.support}</a>.
            </p>
          ),
        },
      ]}
    />
  );
}
